<template>
  <div class="sku-table-wrapper">
    <div class="title-box mb-12" v-if="isMore && tableSelections.length">
      <div class="header input-item">{{ $t('stores::products-info::batch_edit') }}</div>
      <div class="input-item">
        <el-input
          :placeholder="$t('stores::products-info::first_stock')"
          @change="() => onMoreInput('skuInventory')"
          class="item"
          controls-position="right"
          size="mini"
          v-model="edHeader.skuInventory"
        ></el-input>
      </div>
      <div class="input-item">
        <el-input
          :placeholder="$t('stores::products-info::weight')"
          @change="() => onMoreInput('weight')"
          class="item"
          controls-position="right"
          size="mini"
          v-model="edHeader.weight"
        ></el-input>
      </div>
      <div class="input-item">
        <el-input
          :placeholder="$t('stores::products-info::purchase_price')"
          @change="() => onMoreInput('purchasePrice')"
          class="item"
          controls-position="right"
          size="mini"
          v-model="edHeader.purchasePrice"
        ></el-input>
      </div>
      <div class="input-item">
        <el-input
          :placeholder="$t('stores::products-info::compare_at_price')"
          @change="() => onMoreInput('compareAtPrice')"
          class="item"
          controls-position="right"
          size="mini"
          v-model="edHeader.compareAtPrice"
        ></el-input>
      </div>
      <div class="input-item">
        <el-input
          :placeholder="$t('stores::products-info::sale_price')"
          @change="() => onMoreInput('salePrice')"
          class="item"
          controls-position="right"
          size="mini"
          v-model="edHeader.salePrice"
        ></el-input>
      </div>
      <a @click="onMoreInput()">
        <i class="el-icon-check refresh"></i>
      </a>
    </div>
    <ScrollsBar :style="`height: ${isMore ? '560px' : '616px'};`" ref="scroll">
      <div class="cell-body-wrapper" v-if="data && data.length">
        <el-checkbox-group @change="handleCheckedChange" v-model="tableSelections">
          <el-checkbox :disabled="isMore" :key="index" :label="item.id || item.fakeId" v-for="(item, index) in data">
            <div class="cell-box">
              <div class="cell-item">
                <el-image :src="item.imageUrl" class="img-box"></el-image>
              </div>
              <div class="cell-item cel-sku">
                <div class="sku-title">
                  <span class="title">SKU：</span>
                  <span class="desc">{{ $dataCheck(item.id) }}</span>
                </div>
                <div class="sku-content">
                  <span class="content-item">
                    <span class="title">{{ $t('stores::products-info::safe_stock') }}：</span>
                    <span class="desc">{{ $dataCheck(item.safeInventory) }}</span>
                  </span>
                  <span class="content-item">
                    <span class="title">{{ $t('stores::products-info::goods_stock') }}：</span>
                    <span class="desc">{{ $dataCheck(item.skuInventory) }}</span>
                  </span>
                  <span class="content-item">
                    <span class="title">{{ $t('stores::products-info::weight') }}：</span>
                    <span class="desc">{{ $dataCheck(item.weight) }}{{ item.weightUnit }}</span>
                  </span>
                  <template v-if="item.options && item.options.length">
                    <span :key="si" class="content-item" v-for="(stem, si) in item.options">
                      <span class="title">{{ stem.name }}：</span>
                      <span class="desc">{{ $dataCheck(stem.value) }}</span>
                    </span>
                  </template>
                  <div class="edit-content-btn">
                    <el-button
                      @click.native.stop="e => onEdit(e, item, index)"
                      class="edit-btn item-btn"
                      icon="el-icon-edit"
                      type="primary"
                    ></el-button>
                    <el-button
                      @click.native.stop="e => onCopy(e, item, index)"
                      class="copy-btn item-btn"
                      icon="el-icon-copy-document"
                      type="primary"
                    ></el-button>
                    <el-button
                      @click.native.stop="e => onDel(e, item, index)"
                      class="item-btn"
                      icon="el-icon-delete"
                      type="primary"
                    ></el-button>
                  </div>
                </div>
                <div class="sku-fix-content">
                  <span class="content-item">
                    <span class="title">{{ $t('stores::products-info::purchase_price') }}(￥)：</span>
                    <span class="desc">{{ $dataCheck(item.purchasePrice) }}</span>
                  </span>
                  <span class="content-item">
                    <span class="title">{{ $t('stores::products-info::compare_at_price') }}(￥)：</span>
                    <span class="desc">{{ $dataCheck(item.compareAtPrice) }}</span>
                  </span>
                  <span class="content-item">
                    <span class="title">{{ $t('stores::products-info::sale_price') }}(￥)：</span>
                    <span class="desc">{{ $dataCheck(item.salePrice) }}</span>
                  </span>
                </div>
              </div>
            </div>
          </el-checkbox>
        </el-checkbox-group>
      </div>
      <div class="cell-body-wrapper" v-else>
        <div class="empty-content">{{ $t('system::common::btn::no_data') }}</div>
      </div>
    </ScrollsBar>
    <skuModal
      :data="data"
      :drawRow="backRow"
      :selectedSkuOpt="selectedSkuOpt"
      @onAddAttr="$emit('onAddAttr')"
      @save="onSave"
      ref="skuModal"
      v-model="visable"
    ></skuModal>
  </div>
</template>

<script>
import * as Api from '@/server/product'
import ZTable from '@/components/common/table/main'
import skuModal from './sku-modal'
import { createHash } from '@/utils'
export default {
  name: 'sku-table',
  props: {
    data: {
      default: () => {}
    },
    selectedSkuOpt: {
      default: () => []
    }
  },
  components: { ZTable, skuModal },
  data() {
    return {
      visable: false,
      isMore: false,
      backRow: {
        type: 'edit',
        item: {},
        index: undefined
      },
      edHeader: {
        skuInventory: '',
        purchasePrice: '',
        compareAtPrice: '',
        salePrice: '',
        weight: ''
      },
      savePriceLoading: false,
      priceListLoading: false,
      searchData: {
        filterObj: '1',
        shop_id: ''
      },
      setPriceDialogId: null,
      setPriceDialog: false,
      tableSelections: [],
      // currentRow: {
      //   skus: []
      // },
      loading: false
    }
  },
  watch: {
    selectedSkuOpt: {
      handler: function(data) {},
      deep: true,
      immediate: true
    },
    isMore: {
      handler: function(bool) {
        console.log(bool)
        if (!bool) {
          this.edHeader = {
            skuInventory: '',
            purchasePrice: '',
            compareAtPrice: '',
            salePrice: '',
            weight: ''
          }
        }
        if (this.$refs.scroll) {
          this.$refs.scroll.update()
        }
      },
      immediate: true
    },
    data: {
      handler: function(data) {
        console.log('新增sku数据', data)
      },
      deep: true,
      immediate: true
    }
  },
  mounted() {},
  methods: {
    onMoreInput(type) {
      if (!type) {
        let data = []
        for (let i in this.edHeader) {
          this.edHeader[i] = this.mixinRegNum(this.edHeader[i], 2)
          data = this.data.map(item => {
            if (this.tableSelections.includes(item.id)) item[i] = this.mixinRegNum(this.edHeader[i], 2)
            return item
          })
        }
        this.onMore(false)
        this.$emit('update:data', data)
      } else {
        this.edHeader[type] = this.mixinRegNum(this.edHeader[type], 2)
        // const data = this.data.map(item => {
        //   if (this.tableSelections.includes(item.id)) item[type] = this.mixinRegNum(this.edHeader[type], 2)
        //   return item
        // })
        // this.$emit('update:data', data)
      }
    },
    onSave(row, type) {
      if (type === 'add' || type === 'copy') {
        this.$emit('save', row)
      } else {
        const index = this.backRow.index
        this.data.splice(index, 1, row)
        console.log(index, this.data, row)
        // this.$emit('update:data', this.data.splice(index, 1, row))
      }
    },
    //  定价参数统改
    handlePriceChange(data, val) {
      this.currentRow.skus = this.currentRow.skus.map(item => {
        item[data.column.property] = val
        return {
          ...item
        }
      })
    },
    // 获取定价列表
    async getPriceList(id) {
      this.priceListLoading = true
      const { data } = await Api.getPriceList(id)
      this.priceListLoading = false
      if (data.code === this.$code) {
        this.currentRow.skus = data.data
      }
    },
    onMore(bool) {
      this.isMore = bool
      this.$emit('onMoreEdit', bool)
    },
    // 定价
    async handleSetPrice(row) {
      this.setPriceDialog = true
      this.setPriceDialogId = row.spuId
      await this.getPriceList(row.spuId)
    },
    onCopy(e, row, index) {
      this.visable = true
      this.backRow.type = 'copy'
      const data = this.$deepClone(row)
      if (data.hasOwnProperty('id')) {
        delete data.id
      } else if (data.hasOwnProperty('fakeId')) {
        delete data.fakeId
      }
      data.fakeId = createHash(4)
      this.backRow.item = data
      this.backRow.index = index
    },
    onEdit(e, row, index) {
      this.visable = true
      this.backRow.type = 'edit'
      this.backRow.item = row
      this.backRow.index = index
      console.log('edit', row)
    },
    onDel(e, row, index) {
      this.$emit('remove', row)
    },
    onAdd(row, isVisable) {
      this.backRow.type = 'add'
      this.backRow.item = row
      if (!isVisable) {
        this.visable = true
      } else {
        this.$refs.skuModal.updateAttr()
      }
    },
    onBtnClick() {},
    handleCheckedChange(selections) {
      this.tableSelections = selections
      this.$emit('selections', selections)
    },
    // 定价确认
    setPriceConfirm() {
      this.$refs.dynamicValidateForm.validate(async valid => {
        if (valid) {
          this.savePriceLoading = true
          const { data } = await Api.putPriceList({
            spuId: this.setPriceDialogId,
            data: this.currentRow.skus
          })
          this.savePriceLoading = false
          this.setPriceDialog = false
          if (data.code === this.$code) {
            this.$message.success(this.$t('system::tip::control_success'))
            this.handlePageChange()
          }
        }
      })
    }
  }
}
</script>

<style scoped lang="scss">
.sku-table-wrapper {
  .title-box {
    border: 1px solid #999;
    display: flex;
    border-radius: 5px;
    padding: 4px 6px;
    align-items: center;
    .refresh {
      margin-left: 5px;
      cursor: pointer;
    }
    .input-item {
      flex: 1 1 auto;
      padding: 3px;
      .item {
        width: 100%;
      }
    }
    .header {
      flex: 0 0 auto;
      width: 70px;
    }
  }
  .cell-body-wrapper {
    .el-checkbox {
      position: relative;
      box-sizing: border-box;
      overflow: hidden;
      width: 100%;
      padding: 8px;
      display: flex;
      align-items: center;
      transition: background-color 300ms ease;
      border-bottom: 1px solid $--bg-f7;
      .edit-content-btn {
        position: absolute;
        right: -150px;
        top: 50%;
        transform: translateY(-20px);
        font-size: 16px;
        transition: right 300ms ease-in-out;
        z-index: 2;
        width: 85;
        height: 40px;
        padding: 5px;
      }
      .item-btn {
        font-size: 16px;
        color: #fff;
        width: 40px;
        height: 40px;
        padding: 0;
      }

      &:hover {
        background-color: $--bg-f7;
        .edit-content-btn {
          position: absolute;
          right: 10px;
          z-index: 2;
        }
      }
    }
    .cell-box {
      display: flex;
      flex-grow: 1;
      align-items: center;
      .cell-item {
        justify-items: center;
        color: $--text-26;
        display: flex;
        flex-direction: column;
        flex: 0 0 auto;
        width: 62px;
        padding: 3px;
      }
      .cel-sku {
        padding: 8px 0;
        width: auto;
        flex: 1;
      }
      .img-box {
        width: 50px;
        font-size: 12px;
        height: 50px;
        padding-right: 12px;
      }
      .sku-title {
        margin-bottom: 6px;
        .title {
          color: $--text-26;
        }
        .desc {
          white-space: nowrap;
          color: $--text-99;
          text-overflow: ellipsis;
          overflow: hidden;
          max-width: 280px;
          min-width: 200px;
        }
      }
      .sku-content {
        display: flex;
        flex: 1;
        flex-wrap: wrap;
        .content-item {
          padding-right: 5px;
          line-height: 24px;
        }
      }
      .sku-fix-content {
        justify-content: flex-end;
        display: flex;
        position: absolute;
        right: 0;
        top: 15px;
        padding-right: 12px;

        .content-item {
          border: 1px solid #999;
          border-radius: 5px;
          padding: 2px 5px;
          margin-left: 5px;
        }
      }
    }
  }
  .empty-content {
    padding: 50px 0;
    display: flex;
    justify-content: center;
    align-items: center;
    color: #aaa;
  }
}
</style>
